import { Alert, Button, Popconfirm, Space, Table, Typography } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import ApiService from "../../core/service/api-service";
import ArtifactUploadButton from "./ArtifactUploadButton";
import { KIND_INSTALLER, findArtifact, formatBytes, formatDate, publicLauncherUrl } from "./artifact-utils";

/**
 * İlk kurulum dosyaları. Launcher'ın kendini güncellediği paketlerden ayrıdır: bunlar kullanıcının
 * profil menüsünden indirip elle çalıştırdığı setup dosyalarıdır, sürüm numarası taşımazlar.
 */
export default function InstallerTab({ settings, reload }) {
    const { t } = useTranslation();
    const targets = settings.installerTargets ?? [];

    const remove = async (platform) => {
        const response = await ApiService.ViewerSettings.DeleteArtifact(KIND_INSTALLER, 0, platform);
        if (response?.success) reload();
    };

    const rows = targets.map(target => ({
        key: target.key,
        target,
        artifact: findArtifact(settings.artifacts, KIND_INSTALLER, 0, target.key)
    }));

    const columns = [
        { title: t('Platform'), key: 'platform', render: (_, row) => row.target.displayName },
        {
            title: t('File'),
            key: 'file',
            render: (_, row) => row.target.fileName
                ? <a href={publicLauncherUrl(row.target.fileName)} download><DownloadOutlined /> {row.target.fileName}</a>
                : <Typography.Text type="secondary">{row.target.extensions.join(' / ')}</Typography.Text>
        },
        {
            title: t('Size'),
            key: 'size',
            render: (_, row) => row.artifact ? formatBytes(row.artifact.size) : <Typography.Text type="secondary">—</Typography.Text>
        },
        {
            title: t('Uploaded At'),
            key: 'uploadedAt',
            render: (_, row) => formatDate(row.artifact?.uploadedAt)
        },
        {
            title: '',
            key: 'actions',
            render: (_, row) => (
                <Space>
                    <ArtifactUploadButton
                        size="small"
                        accept={row.target.extensions.join(',')}
                        label={row.target.fileName ? t('Replace') : t('Upload installer')}
                        upload={(file, onProgress) => ApiService.ViewerSettings.UploadInstaller(row.target.key, file, onProgress)}
                        onUploaded={reload}
                    />
                    {row.target.fileName && (
                        <Popconfirm title={t('Delete this package?')} onConfirm={() => remove(row.target.key)}>
                            <Button size="small" danger>{t('Delete')}</Button>
                        </Popconfirm>
                    )}
                </Space>
            )
        }
    ];

    return (
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
            <Alert
                type="info"
                showIcon
                message={t('These are the setup files offered in the user menu. They are not versioned: uploading replaces the current file for that platform.')}
            />
            <Table rowKey="key" size="small" pagination={false} dataSource={rows} columns={columns} />
        </Space>
    );
}
